import dayjs from 'dayjs';

export const parseBackendDate = (date: string): Date => dayjs(date + 'Z').toDate();

export const currentDate = (): Date => dayjs().toDate();
